module.exports = __webpack_public_path__ + "img/Expo.d9f02d80.png";